import React from 'react';
import styled from 'styled-components';
import IconRotateCounterClockwiseOutline from './IconRotateCounterClockwiseOutline';
var StyledIconRotateClockwiseOutline = /*#__PURE__*/styled(IconRotateCounterClockwiseOutline).withConfig({
  displayName: "StyledIconRotateClockwiseOutline",
  componentId: "c11n-8-111-1__sc-1jnv8xe-0"
})(["transform:scaleX(-1);"]);
var IconRotateClockwiseOutline = function IconRotateClockwiseOutline(props) {
  return /*#__PURE__*/React.createElement(StyledIconRotateClockwiseOutline, props);
};
export default IconRotateClockwiseOutline;